export const PAYMENTS_ROUTE_PATH = '/payments';
export const ADD_PAYMENT_ROUTE_PATH = '/payment/create';
export const ADD_ANOTHER_PAYMENT_ROUTE_PATH = '/payment/:uuid/create';
export const IMPORT_PAYMENT_ROUTE_PATH = '/payment/import';
